'use client';
import cn from 'classnames';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useMemo } from 'react';
import styles from './timezoneinfoheader.module.scss';

interface TimeZoneInfoHeaderProps {
    className?: string;
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export function TimeZoneInfoHeader(props: TimeZoneInfoHeaderProps): React.JSX.Element {
    const timeZone = useMemo(() => {
        const clientTimeZone = dayjs.tz.guess();

        if (clientTimeZone !== 'Etc/Unknown' && clientTimeZone !== '') {
            const calculatedTimeZone = dayjs.tz(new Date(), clientTimeZone).local().format('z');
            return calculatedTimeZone;
        } else {
            const defaultTimeZone = 'America/New_York';
            const calculatedTimeZone = dayjs.tz(new Date(), defaultTimeZone).local().format('z');
            return calculatedTimeZone;
        }
    }, []);

    return <header className={cn(styles.header, props.className)}>All times listed {timeZone}</header>;
}
